// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BK3E","left":"styles_left__Cm8h-","desktopActions":"styles_desktopActions__o-hS4","title":"styles_title__1YweQ"};